<template>
    <div>
<!--      <div class="swiper-container banner" :style="{'height':height+'rem',}">-->
<!--        &lt;!&ndash;:style="{'height':height+'rem','borderRadius':height==3.22?'10px':''}"&ndash;&gt;-->
<!--        <div class="swiper-wrapper">-->
<!--          <div class="swiper-slide" v-for="(item,index) in list" :key="index">-->
<!--            <a :href="item.pLinkUrl"><img :src="item.pUrl" alt=""></a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="swiper-pagination"></div>-->
<!--      </div>-->
      <swiper :options="swiperOption" class="swiper-wrap banner" :style="{'height':height+'px',}"  ref="mySwiper" v-if="list.length!=0">
        <swiper-slide v-for="(item,index) in list" :key="index" >
          <a :href="item.pLinkUrl">
            <img :src="item.pUrl" alt="" />
          </a>
        </swiper-slide>
        <!-- 常见的小圆点 -->
        <div class="swiper-pagination"  v-for="(item,index) in list" :key="index" slot="pagination" ></div>
      </swiper>
      <!-- 显示数字 -->
<!--      <div class="number">{{imgIndex}}/{{detailimages.length}}</div>-->
    </div>
</template>
<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
  import '../../../static/css/swiper-3.4.2.min.css'
    export default {
        data() {
            return {
                swiperOption: {
                    //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                    notNextTick: true,
                    //循环
                    loop: true,
                    //设定初始化时slide的索引
                    // initialSlide: 0,
                    observeParents: true,
                    //自动播放
                    autoplay: {
                        delay: 2000,
                        stopOnLastSlide: true,
                        /* 触摸滑动后是否继续轮播 */
                        disableOnInteraction: false
                    },
                    //滑动速度
                    // speed: 500,
                    //滑动方向
                    direction: "horizontal",
                    //小手掌抓取滑动
                    // grabCursor: true,
                    on: {
                        //滑动之后回调函数
                        slideChangeTransitionStart: function() {
                            /* realIndex为滚动到当前的slide索引值 */
                            // that.imgIndex= this.realIndex - 1;
                        },
                    },
                    //分页器设置
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                        type: "bullets"
                    }
                }
            }
        },
        props: {
          list:{
            type:Array,
          },
          height:{
            type:Number,
          }
        },
        components:{
            swiper,
            swiperSlide
        },
        methods: {},
        computed: {},
        mounted() {
            // setTimeout(()=>{
            //   let  mySwiper  = new Swiper('.swiper-container',{
            //     autoplay:2000,
            //     pagination : '.swiper-pagination',
            //     autoplayDisableOnInteraction:false,
            //     observer:true,//启动动态检查器  默认false 当样式或者修改swiper子元素的时候自动化初始swiper
            //     // observeParents:false,//当swiper父级元素发生变化时
            //     loop:true,
            //   })
            // },1000)
        }
    }
</script>
<style scoped lang="scss">
  .banner{
    width: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/container/banner.vue